
import axios, { AxiosResponse } from "axios";
import { Component, Prop, Vue } from "vue-property-decorator";
import GlobalConfig from "@/GlobalConfig";
import UmbracoApiService from "@/services/UmbracoApiService";
import WsdlService from "@/services/WsdlService";
import FundTypeObj from "@/models/WsdlResponses/FundTypeObj";
import Swal from "sweetalert2";
import ServicioNotificacionBalanceModel, {
    UserBalanceModel,
} from "@/models/ServicioNotificacionBalance/ServicioNotificacionBalanceModel";

@Component({})
export default class NotificationAportesResponse extends Vue {
	@Prop() email: string;
	@Prop() cel: string;
	@Prop() isEmailActive: boolean;
	@Prop() isCelActive: boolean;
	@Prop() account: string;
    public name: string = `${this.$store.state.user.primerNombre} ${this.$store.state.user.primerApellido}`;

    constructor() {
        super();
    }
    procesar() {}
    returnHome() {
        window.location.href = GlobalConfig.PORTAL_BASE_URL
    }

    async mounted() {
    }
}
